import { transformDates } from './time_utils';

const mergeEnvs = input => {
  const rawEnvs = Object.keys(input);
  const envs = rawEnvs.sort();
  const out = {};

  for (const envName of envs) {
    const env = input[envName];
    const managersUUIDs = Object.keys(env.managers).sort();
    for (const managerUUID of managersUUIDs) {
      out[managerUUID] = out[managerUUID] ? {
        ...out[managerUUID],
        messageStats: [...out[managerUUID].messageStats, env.managers[managerUUID].messageStats],
        adminTimeStats: [...out[managerUUID].adminTimeStats, env.managers[managerUUID].adminTimeStats],
        conversationStats: [...out[managerUUID].conversationStats, env.managers[managerUUID].conversationStats]
      } : {
        ...env.managers[managerUUID],
        messageStats: [env.managers[managerUUID].messageStats],
        adminTimeStats: [env.managers[managerUUID].adminTimeStats],
        conversationStats: [env.managers[managerUUID].conversationStats]
      };
    }
  }
  return out;
};

export const transformStats = input => {
  const perManagerStats = mergeEnvs(input);
  const managersUUIDs = Object.keys(perManagerStats);

  for (const managerUUID of managersUUIDs) {
    const mStats = perManagerStats[managerUUID];
    perManagerStats[managerUUID].nFreeAnswers = mStats.messageStats.map(i => i.filter(i => !i.respToPaidMessage).length);
    perManagerStats[managerUUID].nFreeAnswers.push(perManagerStats[managerUUID].nFreeAnswers.reduce((a, i) => a + i, 0));

    perManagerStats[managerUUID].nPaidAnswers = mStats.messageStats.map(i => i.filter(i => i.respToPaidMessage).length);
    perManagerStats[managerUUID].nPaidAnswers.push(perManagerStats[managerUUID].nPaidAnswers.reduce((a, i) => a + i, 0));

    perManagerStats[managerUUID].nTime = mStats.adminTimeStats.map(i => i.reduce((a, i) => a + i.time / 60., 0));
    perManagerStats[managerUUID].nTime.push(perManagerStats[managerUUID].nTime.reduce((a, i) => a + i, 0));

    perManagerStats[managerUUID].nFirstMessageReplies = mStats.conversationStats.map(i => i.length);
    perManagerStats[managerUUID].nFirstMessageReplies.push(perManagerStats[managerUUID].nFirstMessageReplies.reduce((a, i) => a + i, 0));

    perManagerStats[managerUUID].nConversions = mStats.conversationStats.map(i => i.filter(i => i.paid).length);
    perManagerStats[managerUUID].nConversions.push(perManagerStats[managerUUID].nConversions.reduce((a, i) => a + i, 0));
  }
  return perManagerStats;
};


export const transformEnvStats = input => {
  const envs = Object.keys(input);
  input['All Products'] = {};
  envs.forEach(env => {
    const fields = Object.keys(input[env]);
    fields.forEach(field => {
      if (input['All Products'][field]) {
        input['All Products'][field] += input[env][field];
      } else {
        input['All Products'][field] = input[env][field];
      }
    });
  });
  return input;
};


export const transformDailyStats = input => {
  const envs = Object.keys(input);
  const allProducts = { stats: [] };

  const refEnv = input[envs[0]];
  const refEnvStats = refEnv ? refEnv.stats : [];
  const dates = refEnvStats.map(i => i.date);

  const transformedDates = transformDates(dates);
  const labels = Object.keys(transformedDates);

  const groupedInput = {};

  console.time('grouping');
  for (const env of envs) {
    const envData = input[env].stats;
    groupedInput[env] = { stats: [] };
    for (const xValue of labels) {
      let nFree = 0;
      let nPaid = 0;
      let nReplies = 0;
      let nRepliesWithSuggestions = 0;
      let revenue = 0;

      const dates = transformedDates[xValue];
      for (const date of dates) {
        const snapshot = envData.find(i => date.isSame(i.date, 'day')) || { nFree: 0, nPaid: 0, revenue: 0, nReplies: 0, nRepliesWithSuggestions: 0 };
        nFree += snapshot.nFree;
        nPaid += snapshot.nPaid;
        nReplies += snapshot.nReplies || 0;
        nRepliesWithSuggestions += snapshot.nRepliesWithSuggestions || 0;
        revenue += snapshot.revenue;
      }
      console.table({ x: xValue, nFree, nPaid, revenue: revenue / 100., nReplies, nRepliesWithSuggestions });
      groupedInput[env].stats.push({ x: xValue, nFree, nPaid, revenue: revenue / 100., nReplies, nRepliesWithSuggestions });
    }
  }
  console.timeEnd('grouping');

  for (const xValue of labels) {
    const i = labels.indexOf(xValue);
    const dataSlice = envs.map(n => groupedInput[n].stats[i]);
    const nFree = dataSlice.reduce((a, n) => n.nFree + a, 0);
    const nPaid = dataSlice.reduce((a, n) => n.nPaid + a, 0);
    const nReplies = dataSlice.reduce((a, n) => n.nReplies + a, 0) || 0;
    const nRepliesWithSuggestions = dataSlice.reduce((a, n) => n.nRepliesWithSuggestions + a, 0) || 0;
    const revenue = dataSlice.reduce((a, n) => n.revenue + a, 0);

    allProducts.stats.push({ x: xValue, nFree, nPaid, revenue, nReplies, nRepliesWithSuggestions });
  }

  const transformedInput = { ...groupedInput, 'All Products': allProducts };

  return [transformedInput, labels];
};





// WEBPACK FOOTER //
// ./src/utils/stat_utils.js